import { SESSION_KEY } from './constants';

// Check both localStorage (remember me) and sessionStorage
export const getUserSession = () => {
  try {
    // First check localStorage (remember me)
    let raw = localStorage.getItem(SESSION_KEY);
    if (raw) {
      return JSON.parse(raw);
    }
    // Then check sessionStorage (regular login)
    raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setUserSession = (sess, rememberMe = false) => {
  if (sess) {
    const data = JSON.stringify(sess);
    if (rememberMe) {
      // Save to localStorage for persistence
      localStorage.setItem(SESSION_KEY, data);
      sessionStorage.removeItem(SESSION_KEY);
    } else {
      // Save to sessionStorage for current session only
      sessionStorage.setItem(SESSION_KEY, data);
      localStorage.removeItem(SESSION_KEY);
    }
  } else {
    // Clear both
    sessionStorage.removeItem(SESSION_KEY);
    localStorage.removeItem(SESSION_KEY);
  }
};

export const isSessionValid = () => {
  const s = getUserSession();
  return !!(s && s.user && Date.now() < (s.until || 0));
};
